module.exports = __webpack_public_path__ + "static/media/cap1-04-desk.29f87d20.png";